import { Component, OnInit, ViewEncapsulation, isDevMode } from '@angular/core';
import { Router } from '@angular/router';
import { ServerService } from 'app/core/services/server.service';
import { environment } from 'environments/environment';
import { GlobalService } from '../../core/services/global.service';

@Component({
    selector: 'app-logout',
    templateUrl: './logout.page.html',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [],
    styleUrls: ['./logout.page.scss'],
})
export class LogoutPage implements OnInit {
    public isRedirecting = false;

    constructor(
        private _router: Router,
        private globalService: GlobalService,
        private serverService: ServerService
    ) {}
    ngOnInit(): void {
        // 🚪 Immediately set logout in progress to block further API calls
        this.serverService.setLogoutInProgress();

        this.globalService.loading(true);

        this.clearLocalStorage();
        // reset login status
        this.serverService.post('access/logout', {}, _data => {
            this.handleLogoutRedirect();
        });

        // Stop loading spinner after logout process
        setTimeout(() => {
            this.globalService.loading(false);
        }, 1000);
    }

    private clearLocalStorage(): void {
        const keysToPreserve = [
            'pulse-hotel-selection',
            'selected-entity',
            'account-check-grid',
            'leadsColumnOrder',
        ];
        const valuesToPreserve: { [key: string]: string } = {};
        keysToPreserve.forEach(key => {
            const value = this.globalService.localStorageItem(key);
            if (value) {
                valuesToPreserve[key] = value;
            }
        });

        localStorage.clear();

        // Restore preserved values
        Object.keys(valuesToPreserve).forEach(key => {
            localStorage.setItem(key, valuesToPreserve[key]);
        });
    }

    private handleLogoutRedirect(): void {
        if (environment.company === 'rhg' && !isDevMode()) {
            window.location.href =
                'https://signon.radissonhotels.com/adfs/ls?ReturnTo=https://www.radissonconnects.com';
        } else if (environment.company === 'lhg' && !isDevMode()) {
            window.location.href =
                'https://login.microsoftonline.com/1eda050e-9e19-4f25-bf3d-090e18b9a70f/oauth2/v2.0/logout';
        } else if (isDevMode()) {
            // In development, don't redirect to external sites
            console.log('🚪 [Logout] Development mode - staying on logout page');
        }
    }

    public navigateToHome(): void {
        if (this.isRedirecting) {
            return; // Prevent multiple clicks
        }

        this.isRedirecting = true;

        // Add a small delay to show the loading state
        setTimeout(() => {
            // Check if we should redirect to external logout or internal login
            if (environment.company === 'rhg' && !isDevMode()) {
                if (environment.name === 'staging') {
                    window.location.href = 'https://dev-pulse.radissonhotels.com';
                } else if (environment.name === 'qa') {
                    window.location.href = 'https://qa-pulse.radissonhotels.com';
                } else {
                    window.location.href = 'https://pulse.radissonhotels.com';
                }
            } else if (environment.company === 'lhg' && !isDevMode()) {
                if (environment.name === 'staging') {
                    window.location.href = 'https://dev-lhg-pulse.radissonhotels.com';
                } else {
                    window.location.href = 'https://lhg.pulsebyrhg.com';
                }
            } else {
                // For development or other environments, navigate to home/login
                this._router.navigate(['/']);
            }
        }, 500);
    }
}
